const theme = {
    palette: {
        type: 'light',
        primary: {
            main: '#1E1F20',
            disable: '#2C2F31'
        },
        secondary: {
            main: '#26CE8D',
        },
        background: {
            default: '#131414',
        },
        text: {
            primary: '#ffffff',
            secondary: 'rgba(255,255,255,0.54)',
        },
    },
    colors: {
        navButtonHover: "#26CE8D",
        textColor: "#FFF",
        cardColor: "#1E1F20",
        footerColor: "#161717"
    },
    typography: {
        fontFamily: [
            "Open Sans",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(",")
    }
};

export default theme;